import { customRequest, handleResponse } from "src/helpers";
import { buildQueryString } from "src/utils/helpers";
const config = {
  apiUrl: process.env.VUE_APP_BACKEND_URL,
};

export const subscriptionService = {
  oneTimePayment,
  cancelSubscription,
  getStatus,
  activateSubscriptionCC,
  activateSubscriptionACH,
  getAll,
};

async function oneTimePayment(payload) {
  const requestOptions = {
    ...customRequest("POST"),
    body: JSON.stringify({
      token: payload.token,
      cardType: payload.cardType,
      lastFour: payload.lastFour,
      accountType: payload.accountType,
      firstName: payload.firstName,
      lastName: payload.lastName,
      companyName: payload.companyName,
      expiry: payload.expiry,
      amount: payload.amount,
      invoiceId: payload.invoiceId,
      postalCode: payload.postalCode,
      ecomInd: payload.ecomInd,
      isACH: payload.isACH,
      isCardPointe: payload.isCardPointe,
    }),
  };
  return fetch(`${config.apiUrl}/Subscription/OneTimePayment`, requestOptions)
    .then(handleResponse)
    .then((response) => {
      return {
        data: response,
      };
    });
}

async function cancelSubscription(payload) {
  const requestOptions = {
    ...customRequest("POST", payload),
  };
  return await fetch(
    `${config.apiUrl}/Subscription/Cancel`,
    requestOptions,
  ).then(handleResponse);
}

// async function activateSubscription(params) {
//   const requestOptions = {
//     ...customRequest("POST", {}),
//   };
//   requestOptions.body = "{}";
//   const queryString = buildQueryString(params);
//   return await fetch(
//     `${config.apiUrl}/Subscription/Activate?${queryString}`,
//     requestOptions
//   ).then(handleResponse);
// }

async function activateSubscriptionCC(payload) {
  const requestOptions = {
    ...customRequest("POST"),
    body: JSON.stringify({
      token: payload.token,
      cardType: payload.cardType,
      lastFour: payload.lastFour,
      expirationMonth: payload.expirationMonth,
      expirationYear: payload.expirationYear,
    }),
  };
  return fetch(
    `${config.apiUrl}/Subscription/ActivateCardPointeCredit`,
    requestOptions,
  )
    .then(handleResponse)
    .then((response) => {
      return {
        data: response,
      };
    });
}

async function activateSubscriptionACH(payload) {
  const requestOptions = {
    ...customRequest("POST"),
    body: JSON.stringify({
      token: payload.token,
      lastFour: payload.lastFour,
      accountType: payload.accountType,
    }),
  };
  return fetch(
    `${config.apiUrl}/Subscription/ActivateCardPointeACH`,
    requestOptions,
  )
    .then(handleResponse)
    .then((response) => {
      return {
        data: response,
      };
    });
}

async function getStatus(payload) {
  const requestOptions = {
    ...customRequest("POST", payload),
  };
  return await fetch(
    `${config.apiUrl}/Subscription/Status`,
    requestOptions,
  ).then(handleResponse);
}

async function getAll(params) {
  const requestOptions = {
    ...customRequest("GET"),
  };
  let queryString = buildQueryString(params);
  return await fetch(
    `${config.apiUrl}/Subscription/BillingHistory?${queryString}`,
    requestOptions,
  )
    .then(handleResponse)
    .then((response) => {
      return response;
    });
}
